import { Component, OnInit, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { BogieShimService } from "../bogie-shim.service";
import { InspectionBogieGroup } from "../bogie-shim-model";
import { GETViewPhotoComponent } from "../../../../modules/GET_NEW_UI/shared/view-photo/view-photo.component";
import { PhotoModelComingFrom } from "../../../../modules/GET_NEW_UI/inspections/inspection.model";

@Component({
  selector: "app-bogie-shim-history-popup",
  templateUrl: "./bogie-shim-history-popup.html",
  styleUrls: ["./bogie-shim-history-popup.scss"],
})
export class BogieShimHistoryPopUpComponent implements OnInit {
  equipmentId: number;
  side:number;
  bogieHistoryDetails: InspectionBogieGroup;
  constructor(
    private bogieService: BogieShimService,
    private _dialog: MatDialog,
    private _dialogRef: MatDialogRef<BogieShimHistoryPopUpComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}
  ngOnInit() {
    this.equipmentId = this.data.EquipmentId;
    this.side = this.data.Side;
    this.getBogieHistoryDetails();
  }
  getBogieHistoryDetails() {
    this.bogieService.getBogieHistoryDetails(this.equipmentId, this.side)
    .subscribe((res: any) => {
        console.log("Bogie History Details:", res);
        this.bogieHistoryDetails = res[0].Data; 
        console.log("Bogie History Details:", res.Data);
        console.log("this.bogieHistoryDetails", this.bogieHistoryDetails);
    });
  }

  onNoClick(): void {
    this._dialogRef.close(true);
  }

  ViewInspectionImage(img: string, id :number) {
        const passingData = {
          comingFrom: PhotoModelComingFrom.BogieInspectionImageHistory,
          image: img.replace('Thumbnail_S', ''),
          Id: id,
          ImageUrl: true,
          IsViewMode: true
        };
        const viewInspectionPhoto = this._dialog.open(GETViewPhotoComponent, {
          width: '1032px',
          data: passingData,
        });
        viewInspectionPhoto.afterClosed().subscribe(changes => {
          
        });
    }
}
